import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: '20px',
    fontFamily: theme.typography.fontFamily
  },
  flex: {
    flex: 1
  },
  img: {
    padding: '7px',
    maxHeight: '4em',
    float: 'left',
    maxWidth: '180px',
    marginTop: '21px'
  },
  displayName: {
    lineHeight: '4.7',
    marginLeft: '10px'
  }
});

function DocumentsHeader(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={8} justify="center">
        <Grid item xs={12} lg={10}>
          <Typography variant="title" color="inherit" className={classes.flex}>
            <span className={classes.displayName}>
              {props.user.groupData.logoUrl && (
                <img
                  alt="Logo"
                  className={classes.img}
                  src={props.user.groupData.logoUrl}
                />
              )}
              <strong>Welcome</strong> {props.user.name}
            </span>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

DocumentsHeader.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DocumentsHeader);



// WEBPACK FOOTER //
// ./src/components/DocumentsHeader.js